module.exports = __webpack_public_path__ + "static/media/sastra-login-banner3.4ba6929c.jpg";